import React from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewParams, setReorderIds } from "src/store/community/categoriesSlice";

import PageHeader from "src/componets/PageHeader";
import NavBarThree from "src/componets/NavBarThree";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";
import { selectCategoryIds } from "src/store/community/categoriesSlice";

interface PropsInterface {
  title: string;
}

const TARGET = 'assets';

const _PageHeader = ({ title }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(selectCategoryIds);
  const { app_id } = useParams();

  function onClickCreate() {
    dispatch(setNewParams({ app_id: app_id, target: TARGET }));
  }

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }

  return (
    <PageHeader
      title={title}
      align={'right'}
    >
      <NavBarThree>
        <NavBarThree.Button onClick={onClickSettings}>
          <SettingOutlined /> Category Settings
        </NavBarThree.Button>
        <NavBarThree.Button onClick={onClickCreate}>
          <PlusOutlined /> Create Category
        </NavBarThree.Button>
      </NavBarThree>
    </PageHeader>
  );
}

export default _PageHeader;
